import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownProps } from "../models";

interface Option {
  value: server.dto.DepartArrive;
  label: string;
}

const options: Option[] = [{
  value: "departAt",
  label: RESX.GroundTransport.DepartAt,
}, {
  value: "arriveBy",
  label: RESX.GroundTransport.ArriveBy,
}]

const getOption = (value: server.dto.DepartArrive): Option | undefined => {
  return options.find(o => o.value === value);
}

const DepartAtArriveByDropdown = (props: DropdownProps<server.dto.DepartArrive>) => {
  const selectedOption = getOption(props.value);

  return <BaseReactSelectDropdown
    excludeKeys={[]}
    options={options}
    getLabel={v => v.label}
    getValue={(v) => v.value}
    value={selectedOption}
    onChange={(v) => props.onChange(v.value)}
    config={props.config}
  />;
};

export default DepartAtArriveByDropdown;